const mediaType = {
  movie: 'movie',
  tv: 'tv',
};

const mediaCategory = {
  popular: 'popular',
  top_rated: 'top_rated',
};

const backdropPath = (imgEndpoint) =>
  `https://image.tmdb.org/t/p/original${imgEndpoint}`;

const posterPath = (posterEndPoint) =>
  `https://image.tmdb.org/t/p/original${posterEndPoint}`;

const youtubePath = (videoId) =>
  `https://www.youtube.com/embed/${videoId}?controls=0`;

const tmdbConfigs = {
  mediaType,
  mediaCategory,
  backdropPath,
  posterPath,
  youtubePath,
};

export default tmdbConfigs;
